import http from "./http";
import { filterObj } from "./util";

const regexp = ({ type = 'string', pattern, msg }) => {
    return { type: type, pattern: pattern, message: msg }
};
const required = ({ type = 'string', msg = '该项为必填项' }) => {
    return { required: true, type: type, message: msg }
};
const requiredArray = ({ type = 'Array', msg = '该项为必填项' }) => {
    return { required: true, type: type, message: msg }
};
const requiredNoType = (msg) => {
    return { required: true, message: msg || '该项为必填项' }
};
const remote = ({ url, fieldName, fnSetParam }) => {
    return {
        validator: async (rule, value) => {
            let parameter = Object.assign({}, { [fieldName]: value }, fnSetParam && fnSetParam());
            http({
                url: url,
                method: 'post',
                data: filterObj(parameter),
            }).then(res => {
                let resData = res.data;
                if (resData.code === '00000') {
                    return Promise.resolve();
                } else {
                    return Promise.reject(resData.msg);
                }
            })
        }
    }
};
export default {
    /*email*/
    email: { type: 'email', message: '请输入正确的邮件格式' },
    /*数字*/
    number: { type: 'number', message: '请输入数字' },
    year: { type: 'string', required: true, message: '请选择年份' },
    /*整数*/
    integer: { type: 'integer', message: '请输入整数' },
    /*浮点数*/
    float: { type: 'float', message: '请输入格式为1.00的数字' },
    /*时间*/
    time: { type: 'object', required: true, message: '请选择时间' },
    /*时间范围*/
    range: { type: 'array', required: true, message: '请选择时间范围!' },
    /*金额*/
    amount: regexp({
        type: 'number',
        pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
        msg: '请输入正数金额'
    }),
    /*整正数*/
    IntNumber: regexp({
        type: 'number',
        pattern: /^([1-9]\d*|[0]{1,1})$/,
        msg: '请输入正整数'
    }),
    /*手机,电话号码*/
    mobile_phone: regexp({
        pattern: /^1[0-9]{10,10}$/,
        msg: '请输入正确格式的手机号'
    }),
    phone: regexp({
        pattern: /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/,
        msg: '请输入正确格式的电话号码'
    }),
    /*邮政编码*/
    zip_code: regexp({
        pattern: /^[0-9]{6}$/,
        msg: '请输入正确的邮政编码'
    }),
    /*密码*/
    password: regexp({
        // pattern: /^(?=.*\d)(?=.*[a-zA-Z~!@#$%^&*()_+`\-={}:";'<>?,.\\/“”，。？！【】：·、；]).{6,16}$/,
        // pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[A-Za-z0-9\W_]{12,}$/,
        // pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W_]).{12,}$/,
        pattern:/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+[{\]}\\|;:'",<.>/?]).{12,}$/,
        msg: '密码必须由大写字母，小写字母，数字及特殊符号组成且长度在12位以上'
    }),
    /*身份证*/
    id_num: regexp({
        pattern: /^[1-9]\d{5}[1-9]\d{3}(((0[13578]|1[02])(0[1-9]|[12]\d|3[0-1]))|((0[469]|11)(0[1-9]|[12]\d|30))|(02(0[1-9]|[12]\d)))(\d{4}|\d{3}[xX])$/,
        msg: '请输入有效的身份证号码'
    }),
    /* 统一社会信用代码 */
    oraganizationCode: regexp({
        pattern: /^(([0-9A-Za-z]{15})|([0-9A-Za-z]{18})|([0-9A-Za-z]{20}))$/,
        msg: '请输入正确的统一社会信用代码'
    }),
    /* 高企编号 */
    highCorpCode: regexp({
        // pattern: /^G[RF]2\d{3}\d{3}\d{5}$/,
        pattern: /^\S*$/,
        msg: '请输入正确的高企编号'
    }),
    /* 科技型中小企业编号 */
    scienceTechnologySmes: regexp({
        // pattern: /^G[RF]2\d{3}\d{3}\d{5}$/,
        pattern: /^\S*$/,
        msg: '请输入正确的科技型中小企业编号'
    }),
    /*多选*/
    multiple: required({
        type: 'array',
        msg: '请至少选择一项'
    }),
    chineseString: regexp({
        pattern: /^(?:[\u4e00-\u9fa5·]{2,16})$/,
        msg: '请输入正确的姓名'
    }),
    space: regexp({
        pattern: /^\S*$/,
        msg: '不能输入空格'
    }),
    firstSpace: regexp({
        pattern: /^\S+/,
        msg: '不能以空格开头'
    }),
    allSpace: regexp({
        pattern: /^(?=.*\S).+$/,
        msg: '不能全部是空格'
    }),
    /*正则*/
    regexp,
    /*必填*/
    required,
    requiredNoType: requiredNoType,
    requiredArray,
    /*远程验证*/
    remote,
};
